import KisTabs from 'kis-tabs';

class Switcher {
	constructor() {
		this.container = document.querySelector('.milestones__tabs');
		this.buttons = Array.from(document.querySelectorAll('.milestones__tab-button'));
		this.switcher = document.querySelector('.milestones__tab-switcher');
		this.switcherIndicator = this.switcher.querySelector('div');
		this.currentTab = 0;
	}

	init = () => {
		const tabs = new KisTabs({
			tabSelector: '.milestones__container',
			btnSelector: '.milestones__tab-button',
			initialTab: 0,
		});

		tabs.init();

		this.switcherIndicator.style.transform = 'translate(-12px)';
		this.switcher.addEventListener('click', () => { this.goTo(tabs); });
		this.buttons.forEach((el, index) => {
			el.addEventListener('click', () => { this.moveIndicatorByButton(index); });
		});
	};

	goTo = (tabsInstance) => {
		const targetIndex = this.currentTab === 0 ? 1 : 0;
		tabsInstance.goTo(targetIndex);
		this.currentTab = targetIndex;
		this.moveIndicator();
	};

	moveIndicator = () => {
		this.switcherIndicator.style.transform = `translate(${12 * (this.currentTab === 0 ? -1 : 1)}px)`;
	};

	moveIndicatorByButton = (index) => {
		this.currentTab = index;
		this.moveIndicator();
	};
}

export default Switcher;
